import { Injectable } from '@angular/core';
import { InMemoryDbService, ResponseOptions, getStatusText, STATUS, ParsedRequestUrl, RequestInfo, RequestInfoUtilities } from 'angular-in-memory-web-api';
import { Observable } from 'rxjs';
import { ASSETMOCK } from 'src/assets/data/mock-data/asset';
import { PROFILEMOCK } from 'src/assets/data/mock-data/profile';
import { LoggerService } from './logger.service';






@Injectable({
  providedIn: 'root'
})
export class InMemoryDataService implements InMemoryDbService {

  constructor(private logger: LoggerService) { }

  createDb() {
    this.logger.warn("InMemoryWebApi - Active!");
    const userProfile = null;
    const asset = null;
    return {userProfile, asset};
  }


  // Overrides id generator and delivers next available `id`, starting with 1001.
  // genId<T extends { id: any }>(collection: T[], collectionName: string): any {
  //   if (collectionName === 'nobodies') {
  //     this.logger.debug('genId override for \'nobodies\'');
  //     return guid();
  //   } else if (collection) {
  //     this.logger.debug(`genId override for '${collectionName}'`);
  //     return 1 + collection.reduce((prev, curr) => Math.max(prev, curr.id || 0), 1000);
  //   }
  // }


   // HTTP POST interceptor
   post(reqInfo: RequestInfo): Observable<any> {
    this.logger.debug(`POST: `, reqInfo, 'http');
    const collectionName = reqInfo.collectionName;
    if (collectionName === 'userProfile') {
      return this.getMockProfile(reqInfo);
    }
    return undefined; // let the default POST handle all others
  }


  private getMockProfile(reqInfo: RequestInfo) {
    return reqInfo.utils.createResponse$(() => {
      const dataEncapsulation = reqInfo.utils.getConfig().dataEncapsulation;
      const options: ResponseOptions = {
          body: dataEncapsulation ? { PROFILEMOCK } : PROFILEMOCK,
          status: STATUS.OK
        }
      return this.finishOptions(options, reqInfo);
    });
  }



     // HTTP PUT interceptor
     put(reqInfo: RequestInfo): Observable<any> {
      const collectionName = reqInfo.collectionName;
      if (collectionName === 'asset') {
        return this.getMockAssets(reqInfo);
      }
      return undefined; // let the default POST handle all others
    }

    private getMockAssets(reqInfo: RequestInfo) {
      return reqInfo.utils.createResponse$(() => {
        const dataEncapsulation = reqInfo.utils.getConfig().dataEncapsulation;
        const options: ResponseOptions = {
            body: dataEncapsulation ? { ASSETMOCK } : ASSETMOCK,
            status: STATUS.OK
          }
        return this.finishOptions(options, reqInfo);
      });
    }

   // parseRequestUrl override
   // Do this to manipulate the request URL or the parsed result
   // into something your data store can handle.
   // This example turns a request for `/profile/userProfile` into just `/userProfile`.
   // It leaves other URLs untouched and forwards to the default parser.
   // It also logs the result of the default parser.

   parseRequestUrl(url: string, utils: RequestInfoUtilities): ParsedRequestUrl {
    const originalUrl = utils.parseRequestUrl(url);
    if (url.indexOf("profile/userProfile") > -1) {
      const newUrl = url.replace(/\/profile\/userProfile/, '/userProfile');
      const modifiedUrl = utils.parseRequestUrl(newUrl);
     // this.logger.debug(`In Memory Web API (userProfile) - 'parseRequestUrl' override of '${url}':`, modifiedUrl);
      return modifiedUrl;
    }
    if(url.indexOf("/assets/data/") > -1) {
      return originalUrl;

    }

    return originalUrl;
  }

     // intercept ResponseOptions from default HTTP method handlers
   // add a response header and report interception to console.log
  //  responseInterceptor(resOptions: ResponseOptions, reqInfo: RequestInfo): ResponseOptions {
  //   resOptions.headers = resOptions.headers.set('x-test', 'test-header');
  //   const method = reqInfo.method.toUpperCase();
  //   const body = JSON.stringify(resOptions);
  //   this.logger.debug(`In Memory Web API () - 'responseInterceptor': ${method} ${reqInfo.req.url}: \n${body}`);
  //   return resOptions;
  // }

     /////////// helpers ///////////////

     private finishOptions(options: ResponseOptions, {headers, url}: RequestInfo) {
      options.statusText = getStatusText(options.status);
      options.headers = headers;
      options.url = url;
      return options;
    }

}
